import { createApp } from 'vue';
import dJSON from 'dirty-json';
import module from './module.vue';

// mount selector
const moduleSelector = '.sds-widget';

/**
 * Vue.js Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules) return;

  modules.forEach((query) => {
    try {
      const data = dJSON.parse(query.data);

      // vue components init
      createApp(module, { data }).mount(query);
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
